import React from 'react';
import { Button, Icon } from 'anf-core-react';

export default function AddToBagButton({
  handleAddToBag,
  activeButtonLabel,
  brand,
  label,
  isButtonDisabled,
  hasSelectableSoldOutSizeTiles,
}) {
  const isSuccessState = ['addedToMyBag', 'addToBagAdded', 'updateToBagSuccess'].includes(activeButtonLabel);
  const isReadyState = ['addToBagReady', 'addToMyBagReady', 'addToBagUrgency', 'updateToBagReady'].includes(activeButtonLabel);
  const isProcessingState = activeButtonLabel === 'addToBagProcessing';
  const isSoldOutState = (activeButtonLabel === 'addToBagSoldOut') && hasSelectableSoldOutSizeTiles;
  const isAtbDisabled = isProcessingState || isSuccessState || isButtonDisabled || isSoldOutState;

  return (
    <div className="product-add-to-bag-button-container" data-product-brand={brand === 'gh' ? 'hol' : brand} data-testid="product-add-to-bag-button-container">
      <Button
        classList="product-add-to-bag-button-container_button"
        variant={isReadyState || isSoldOutState ? 'primary' : 'secondary'}
        brand={brand === 'gh' ? 'hol' : brand}
        isProcessing={isProcessingState}
        isFullWidth
        isDisabled={isAtbDisabled}
        onClick={handleAddToBag}
      >
        {isSuccessState && <Icon icon="bag-checkmark" />}
        {label}
      </Button>
    </div>
  );
}
